"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimer = void 0;
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var useTimer = function (_a) {
    var endDate = _a.endDate;
    var endDateInDate = (0, react_1.useMemo)(function () { return (endDate ? new Date(endDate) : new Date()); }, [endDate]);
    var currentDate = new Date();
    var daysLeft = (0, date_fns_1.differenceInDays)(endDateInDate, currentDate);
    currentDate = (0, date_fns_1.addDays)(currentDate, daysLeft);
    var hoursLeft = (0, date_fns_1.differenceInHours)(endDateInDate, currentDate);
    currentDate = (0, date_fns_1.addHours)(currentDate, hoursLeft);
    var minutesLeft = (0, date_fns_1.differenceInMinutes)(endDateInDate, currentDate);
    currentDate = (0, date_fns_1.addMinutes)(currentDate, minutesLeft);
    var secondsLeft = (0, date_fns_1.differenceInSeconds)(endDateInDate, currentDate);
    var checkIsNegative = (0, react_1.useCallback)(function (str) {
        var number = parseFloat(str);
        return !isNaN(number) && number < 0;
    }, []);
    var formatWithZero = (0, react_1.useCallback)(function (num) {
        var isNegative = checkIsNegative(num);
        return isNegative ? '00' : String(num).padStart(2, '0');
    }, [checkIsNegative]);
    var _b = (0, react_1.useState)({
        days: formatWithZero(daysLeft),
        hours: formatWithZero(hoursLeft),
        minutes: formatWithZero(minutesLeft),
        seconds: formatWithZero(secondsLeft),
    }), time = _b[0], setTime = _b[1];
    (0, react_1.useEffect)(function () {
        var timer = setTimeout(function () {
            setTime({
                days: formatWithZero(daysLeft),
                hours: formatWithZero(hoursLeft),
                minutes: formatWithZero(minutesLeft),
                seconds: formatWithZero(secondsLeft),
            });
        }, 1000);
        return function () { return clearTimeout(timer); };
    });
    return (0, react_1.useMemo)(function () {
        if (!endDateInDate)
            return {
                time: {
                    days: formatWithZero(0),
                    hours: formatWithZero(0),
                    minutes: formatWithZero(0),
                    seconds: formatWithZero(0),
                },
            };
        return { time: time };
    }, [endDateInDate, time, formatWithZero]);
};
exports.useTimer = useTimer;
exports.default = exports.useTimer;
